import './heading.sass';

export { default } from './heading';
